<footer class="footer">
  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="copy-right text-left">© {{currentYear}} S1AZ.COM. All rights reserved</div>
        </div>
        <div class="col-md-6 col-xs-12">
          <ul class="social-media">
            <li *ngFor="let social of socialMedia">
              <a href="https://whatsapp.com/channel/0029Vb681eNHrDZgPO2Wni1E" target="_blank"
                 [ngClass]="social.icon"></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
